// Lazy-loader for things-data.json — the slim Things metadata + trait
// inverted index that lives in public/things-data.json.
//
// Why this exists: the original thingdoms_ordered.json is 17 MB. Statically
// importing it baked the whole thing into the JS bundle, slowing every page
// visit. This module fetches the slim version only on demand, caches the
// result, and exposes lookups for the two real use cases:
//   - getThingTraits(id)         → traits for the detail page
//   - getIdsForTrait(type, value) → ID list for the gallery's trait filter

let dataPromise = null;

function loadData() {
  if (dataPromise) return dataPromise;
  dataPromise = fetch('/things-data.json')
    .then((res) => {
      if (!res.ok) throw new Error(`things-data.json ${res.status}`);
      return res.json();
    })
    .catch((err) => {
      // Reset so a future call retries instead of returning the rejected promise forever.
      dataPromise = null;
      throw err;
    });
  return dataPromise;
}

export async function getThingTraits(id) {
  const data = await loadData();
  const entry = data.by_id[id - 1];
  if (!entry) return [];
  // Inflate short keys back to the names the rest of the site uses.
  return entry.traits.map((t) => ({ trait_type: t.t, trait_value: t.v }));
}

export async function getIdsForTrait(traitType, traitValue) {
  const data = await loadData();
  return data.by_trait[`${traitType}|${traitValue}`] || [];
}
